import React, { ReactElement, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { List } from 'immutable';

// Components
import LabelsSearchBar from './components/LabelsSearchBar';
import LabelsCreateButtons from './components/LabelsCreateButtons';
import LabelLists from './components/LabelLists';

// Utils
import { getElementId } from '../../../../../../common/elements/utils/elementPropertyUtils';
import useLabelHandlers from './hooks/useLabelHandlers';

// Selectors
import { getElement } from '../../../../../element/selectors/elementSelector';
import { getSelectedTaskIdSelector } from '../../../selector/selectionToolsSelector';

// Types
import { LabelsToolContentProps } from './labelComponentPropTypes';
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';

import './LabelsToolContent.scss';

const LabelsToolContent = (props: LabelsToolContentProps): ReactElement => {
    const { handleClickEdit, selectedElements, allLabels, userRootPath } = props;

    const [searchString, setSearchString] = useState<string>('');

    const elementIds = selectedElements.map(getElementId).toArray();
    const selectedTaskListId = useSelector(getSelectedTaskIdSelector);
    const focusElementIds = selectedTaskListId ? [selectedTaskListId] : elementIds;
    const elements: List<ImMNElement> = useSelector((state) => {
        return List(focusElementIds.map((elementId) => getElement(state, { elementId })));
    });

    const { handleToggleLabelSelection, handleCreateLabel, handleSearchSubmit } = useLabelHandlers(
        props,
        searchString,
        setSearchString,
        elements,
        allLabels,
    );

    const showCreateButtons = useMemo(
        () => searchString && !allLabels.some((label) => label.name === searchString),
        [searchString, allLabels],
    );
    return (
        <div className="LabelsToolContent">
            <LabelsSearchBar value={searchString} onChange={setSearchString} handleSearchSubmit={handleSearchSubmit} />
            <LabelLists
                handleToggleLabelSelection={handleToggleLabelSelection}
                handleClickEdit={handleClickEdit}
                elements={elements}
                searchString={searchString}
                allLabels={allLabels}
            />
            {showCreateButtons && (
                <LabelsCreateButtons handleCreateLabel={handleCreateLabel} userRootPath={userRootPath} />
            )}
        </div>
    );
};

export default LabelsToolContent;
